var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135.85,
    height: 135.85,
    viewBox: "0 0 135.85 135.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M246.693,331.325a67.925,67.925,0,1,0,67.925,67.925A68,68,0,0,0,246.693,331.325Zm0,6.457a61.419,61.419,0,0,1,46.781,101.273c-42.4-37.119-83.882-9.1-94.3-.863a61.433,61.433,0,0,1,47.519-100.41Zm2.114,122.61c-27.178,0-39.557-14.557-40.106-15.22a2.732,2.732,0,0,1,4.2-3.49c.542.643,13.132,15.174,41.5,13.031a2.729,2.729,0,0,1,.437,5.441l-.061.009C252.72,460.318,250.723,460.392,248.807,460.392Z",
    transform: "translate(-178.768 -331.325)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 25.619,
    cy: 25.619,
    r: 25.619,
    transform: "translate(42.306 26.628)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilePlaceholder);
export default __webpack_public_path__ + "static/media/ProfilePlaceholder.f33a2b85.svg";
export { ForwardRef as ReactComponent };